import { c as _c } from "react/compiler-runtime";
import { FormEvent } from "react";
import clsx from "classnames";
import { useAnonymousNewslettersContext } from "modules/newsletters/contexts";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
import { Loader2 } from "lucide-react";
interface SubscriptionFormProps {
  onSubmit: (e?: FormEvent) => void;
  isLoading: boolean;
  selectedCount: number;
}

/**
 * Email input form with subscribe button.
 * Manages email state through NewslettersV2Context.
 */
export const SubscriptionForm = t0 => {
  "use memo";

  const $ = _c(32);
  const {
    onSubmit,
    isLoading,
    selectedCount
  } = t0;
  const {
    email,
    setEmail
  } = useAnonymousNewslettersContext();
  const t = useTranslations("newsletters");
  const t1 = isLoading ? "true" : "false";
  let t2;
  if ($[0] !== t) {
    t2 = t("v2.input.email_label");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("v2.input.email_placeholder");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== setEmail) {
    t4 = e => setEmail(e.target.value);
    $[4] = setEmail;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== email || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <input id="email" type="email" name="email" autoComplete="email" aria-label={t2} placeholder={t3} value={email} onChange={t4} required={true} className="mb-6 h-12 w-full rounded-full border !border-black px-4 py-3 pr-32 text-base font-normal placeholder:font-normal placeholder:text-gray-500 focus:!border-black focus:ring-2 focus:ring-black focus:ring-offset-2 focus:outline-none" />;
    $[6] = email;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = selectedCount === 0 || isLoading;
  const t7 = selectedCount === 0;
  const t8 = selectedCount > 0;
  let t9;
  if ($[11] !== isLoading || $[12] !== t7 || $[13] !== t8) {
    t9 = clsx("relative h-10 rounded-full px-4 text-sm text-white", {
      "cursor-not-allowed bg-gray-300": t7,
      "bg-black hover:bg-gray-800": t8,
      "pointer-events-none !bg-gray-600": isLoading
    });
    $[11] = isLoading;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = isLoading ? "opacity-0" : "opacity-100";
  let t11;
  if ($[15] !== t) {
    t11 = t("button.subscribe");
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <span className={t10}>{t11}</span>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== isLoading) {
    t13 = isLoading && <Loader2 data-testid="loading-spinner" className="absolute top-1/2 left-1/2 size-5 -translate-x-1/2 -translate-y-1/2 animate-spin" />;
    $[20] = isLoading;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13 || $[24] !== t6 || $[25] !== t9) {
    t14 = <div className="absolute top-1 right-1"><button type="submit" disabled={t6} className={t9}>{t12}{t13}</button></div>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t6;
    $[25] = t9;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== onSubmit || $[28] !== t1 || $[29] !== t14 || $[30] !== t5) {
    t15 = <form onSubmit={onSubmit} className="relative w-full max-w-lg" aria-busy={t1} aria-describedby="subscribe-help" data-testid="subscription-form">{t5}{t14}</form>;
    $[27] = onSubmit;
    $[28] = t1;
    $[29] = t14;
    $[30] = t5;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
};